<template>
	<div>
        <!-- @on-row-dblclick="onEditClick" -->
		<vue-good-table
			mode="remote"
			@on-page-change="onPageChange"
			@on-sort-change="onSortChange"
			@on-column-filter="onColumnFilter"
			@on-per-page-change="onPerPageChange"
			:totalRows="totalRecords"
			:isLoading.sync="isLoading"
			:rows="rows"
			:columns="columns"
			
			:select-options="{ enabled: false }"
			:pagination-options="{ enabled: true }"
		>		  	
		  	<template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'payment'">
                    <span v-if="props.row.payment && props.row.status == 'active'">
                        {{ props.row.payment.amount_incl | currency }}
                    </span>
                    <span v-if="props.row.payment && props.row.status == 'payment_pending'" @click="newPayment(props.row)" class="text-danger" :title="'user.reservations.payment_pending' | translate" role="button">
                        {{ props.row.payment.amount_incl | currency }}*
                    </span>
                    <span v-else></span>
                </span>
        		<span v-else-if="props.column.field == 'actions'">
					<div v-if="props.row.can_delete" class="btn-group">
						<a href="#" class="btn btn-sm btn-danger" @click="onDeleteClick(props)"><i class="far fa-trash-alt fa-fw"></i></a>
					</div>
				</span>
				<span v-else>
					{{props.formattedRow[props.column.field]}}
				</span>
      		</template>
		</vue-good-table>
		
	</div>
</template>

<script>
export default {
	name: 'user-reservations-datatable',
	props: [
		'getUrl',
		'deleteUrl',
	],
    created() {
        this.loadItems();
	},
	data() {
		return {
			csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
			deleteFormAction: '#',
			isLoading: false,
			columns: [
				{
					label: '',
                    field: 'actions',
                    tdClass: 'py-2',
					sortable: false,
					width: '40px',
				},
				{
					label: this.translate('user.reservations.company_name'),
					field: 'company_name',
					/* filterOptions: {
						enabled: true,
						trigger: 'enter',
					}, */
				},
				{
					label: this.translate('user.reservations.timeslot'),
					field: 'timeslot',
				},
				{
					label: this.translate('user.reservations.firstname'),
					field: 'firstname',
				}
				/* {
					label: this.translate('user.reservations.num_guests'),
					field: 'num_guests',
				}, */
				/* {
					label: this.translate('user.reservations.inside'),
					field: 'inside',
				}, */
				/*{
					label: this.translate('user.reservations.payment'),
					field: 'payment',
				},*/
			],
			rows: [],
			totalRecords: 0,
			serverParams: {
				columnFilters: {},
				sort: [{
					field: 'timeslot', 
					type: 'desc',
				}],
				page: 1, 
				perPage: 10,
			}
		};
	},
	methods: {
		updateParams(newProps) {
			this.serverParams = Object.assign({}, this.serverParams, newProps);
		},
		
		onPageChange(params) {
			this.updateParams({page: params.currentPage});
			this.loadItems();
		},

		onPerPageChange(params) {
			this.updateParams({perPage: params.currentPerPage});
			this.loadItems();
		},

		onSortChange(params) {
			this.updateParams({
				sort: [{
					type: params[0].type,
					field: params[0].field, // this.columns[params.columnIndex].field,
				}],
			});
			this.loadItems();
		},
		
		onColumnFilter(params) {
			this.updateParams(params);
			this.updateParams({page: 1});
			this.loadItems();
		},

		onDeleteClick(params) {

            this.deleteConfirm.fire({
                title: this.translate('user.reservations.delete_confirm.title'), 
                text: this.translate('user.reservations.delete_confirm.text'),
                confirmButtonText: this.translate('user.reservations.delete_confirm.confirm_button'),
                cancelButtonText: this.translate('user.reservations.delete_confirm.cancel_button'),
            }).then((result) => {
                if(result.value) {

                    this.showLoader();

                    axios.post(this.deleteUrl.replace(':id:', params.row.id), {
                    })
                    .then(response => {
                        this.hideLoader();
                        
                        this.loadItems();
                    }).catch(error => {
                        this.hideLoader();

                        if(error && error.response && error.response.status == 422) {
                            if(error.response.data.message) {
                                Swal.fire({
                                    icon: 'error',
                                    title: error.response.data.message,
                                });
                            }
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: this.translate('error'),
                            });
                        }
                    });

                }
            });
        },
        
        newPayment(row)
        {
            window.location.href = this.routes.user.dashboard_new_payment.replace(':id:', row.id);
        },

		// load items is what brings back the rows from server
		loadItems() {
			axios.post(this.getUrl, this.serverParams) // qs.stringify(this.serverParams)
			.then(response => {
				this.totalRecords = response.data.totalRecords;
				this.rows = response.data.rows;
			}).catch(errors => {
				console.log(errors);
			});
			/*getFromServer(this.serverParams).then(response => {
				this.totalRecords = response.totalRecords;
				this.rows = response.rows;
			});*/
		}
	}
};
</script>
